import ServiceInstructionModel from "@/models/lab/ServiceInstructionModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

export default class ServiceInstructionCollection extends LabServiceCollection {
  model() {
    return ServiceInstructionModel;
  }

}
